(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["estimated-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('estimated-delivery')) {
    customElements.define(
      'estimated-delivery',
      class EstimatedDelivery extends HTMLElement {
        connectedCallback() {
          this.updateDates();

          // Refresh for customers who keep the page open overnight.
          this.refreshTimer = window.setInterval(
            () => this.updateDates(),
            60000
          );
        }

        disconnectedCallback() {
          window.clearInterval(this.refreshTimer);
        }

        getOrderDate() {
          const timezone = this.dataset.timezone.trim() || 'Asia/Karachi';

          let formatter;

          try {
            formatter = new Intl.DateTimeFormat('en-US', {
              timeZone: timezone,
              year: 'numeric',
              month: '2-digit',
              day: '2-digit'
            });
          } catch (error) {
            formatter = new Intl.DateTimeFormat('en-US', {
              timeZone: 'Asia/Karachi',
              year: 'numeric',
              month: '2-digit',
              day: '2-digit'
            });
          }

          const parts = formatter.formatToParts(new Date());
          const values = {};

          parts.forEach(part => {
            values[part.type] = part.value;
          });

          // UTC is used for date-only arithmetic to avoid DST shifts.
          return new Date(Date.UTC(
            Number(values.year),
            Number(values.month) - 1,
            Number(values.day),
            12
          ));
        }

        addDays(start, amount) {
          const result = new Date(start.getTime());
          const skipWeekends = this.dataset.weekends === 'true';
          let remaining = amount;

          while (remaining > 0) {
            result.setUTCDate(result.getUTCDate() + 1);

            const weekday = result.getUTCDay();

            if (!skipWeekends || (weekday !== 0 && weekday !== 6)) {
              remaining -= 1;
            }
          }

          return result;
        }

        formatDate(date) {
          const options = {
            timeZone: 'UTC',
            month: 'short',
            day: 'numeric'
          };

          if (this.dataset.year === 'true') {
            options.year = 'numeric';
          }

          const locale = this.dataset.locale.trim() || 'en-US';

          try {
            return new Intl.DateTimeFormat(locale, options).format(date);
          } catch (error) {
            return new Intl.DateTimeFormat('en-US', options).format(date);
          }
        }

        updateDates() {
          const ordered = this.getOrderDate();
          const dispatchDays = Math.max(
            0,
            Number(this.dataset.dispatch) || 0
          );
          const minimumDays = Math.max(
            0,
            Number(this.dataset.min) || 0
          );
          const maximumDays = Math.max(
            minimumDays,
            Number(this.dataset.max) || 0
          );

          const shipped = this.addDays(ordered, dispatchDays);
          const earliest = this.addDays(shipped, minimumDays);
          const latest = this.addDays(shipped, maximumDays);

          const shippedElement = this.querySelector(
            '[data-ed-date="shipped"]'
          );
          const deliveredElement = this.querySelector(
            '[data-ed-date="delivered"]'
          );

          if (shippedElement) {
            shippedElement.textContent = this.formatDate(shipped);
          }

          if (deliveredElement) {
            deliveredElement.textContent =
              earliest.getTime() === latest.getTime()
                ? this.formatDate(earliest)
                : `${this.formatDate(earliest)} – ${this.formatDate(latest)}`;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
